import moment from 'moment';

const isValidDate = dateString => {
  const date = moment(dateString, 'YYYY-MM-DD', true);
  if (!date.isValid()) return false;
  const today = moment().startOf('day');
  const minDate = moment().subtract(100, 'years').startOf('day');
  return date.isSameOrAfter(minDate) && date.isSameOrBefore(today);
};

export default isValidDate;
